const KEY = 'pulse_client_portal';
const DAY = 24 * 60 * 60 * 1000;

export function readClientCreds() {
    try {
        const raw = window.localStorage.getItem(KEY);
        if (!raw) return null;
        const row = JSON.parse(raw);
        if (!row.phone || !row.pin) return null;
        if (row.expiresAt && Date.now() > row.expiresAt) {
            window.localStorage.removeItem(KEY);
            return null;
        }
        return {
            phone: String(row.phone),
            pin: String(row.pin),
            tenantSlug: row.tenantSlug ? String(row.tenantSlug) : ''
        };
    } catch (err) {
        return null;
    }
}

export function saveClientCreds({ phone, pin, tenantSlug }) {
    window.localStorage.setItem(KEY, JSON.stringify({
        phone: String(phone || '').trim(),
        pin: String(pin || '').trim(),
        tenantSlug: String(tenantSlug || '').trim(),
        expiresAt: Date.now() + 30 * DAY
    }));
}

export function clearClientCreds() {
    window.localStorage.removeItem(KEY);
}

export function splitPolicyBlock(block) {
    const all = block.policies && block.policies.length
        ? block.policies
        : [...(block.cards || []), ...(block.pending || [])];
    const pending = all.filter((p) => {
        const s = String(p.status || '').toUpperCase();
        return s === 'PENDING' || s === 'QUOTE' || s === 'DRAFT';
    });
    const cards = all.filter((p) => {
        const s = String(p.status || '').toUpperCase();
        return s !== 'PENDING' && s !== 'QUOTE' && s !== 'DRAFT';
    });
    return { all, cards, pending };
}
